import React, { Fragment } from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import Hero from '../employee-branding/hero/hero';
import CompanyDepartments from './company-departments/company-departments';

const CareersPage = () => (
  <Fragment>
    <div
      className={classNames([
        classes('margin-bottom-4'),
        classes('margin-bottom-5--wide'),
      ])}
    >
      <Hero
        backgroundColor="#E3FAF2"
        title="Find your fit"
        copy="Browse our teams to see our current openings."
        showCareerBreadcrumbs
        careerBreadcrumbLevel="1"
        imageUrlMobile="https://www.nerdwallet.com/cdn/company/2021/hero/Teams-overview-Hero-Mobile.jpg"
        imageUrlDesktop="https://www.nerdwallet.com/cdn/company/2021/hero/Teams-overview-Hero-Desktop.jpg"
      />
    </div>
    <CompanyDepartments />
  </Fragment>
);

CareersPage.displayName = 'Careers Page';

export default CareersPage;
